import React from "react";
import { Link } from "react-router-dom";
import { Icon, Thumbnail } from "@culturehq/components";

import inviteTypes from "constants/inviteTypes";
import { ProfileLink } from "app/links";

import getUserName from "app/utils/getUserName";
import InviteButton from "./InviteButton";

const getGroupLink = (inviteType, entity) => {
  if (inviteType.key === "organizationIds") {
    return "/community";
  }
  return `/community?${inviteType.link}=${entity.id}`;
};

const GroupRow = ({ entity, event, onRefreshInvitations }) => {
  const inviteType = inviteTypes[entity.type];

  return (
    <tr>
      <td>
        <div className="Icon">
          <Icon icon={inviteType.icon} />
        </div>
      </td>
      <td>
        <Link to={getGroupLink(inviteType, entity)}>
          {entity.name} <span className="light">({inviteType.name})</span>
        </Link>
      </td>
      <td className="text-center">
        <InviteButton entity={entity} event={event} onRefreshInvitations={onRefreshInvitations} />
      </td>
    </tr>
  );
};

const UserRow = ({ user, event, onRefreshInvitations }) => (
  <tr>
    <td>
      <Thumbnail image={user.avatar.thumbUrl} title={getUserName(user)} />
    </td>
    <td>
      <ProfileLink user={user} />
    </td>
    <td className="text-center">
      <InviteButton entity={user} event={event} onRefreshInvitations={onRefreshInvitations} />
    </td>
  </tr>
);

const EntityRow = ({ entity, event, onRefreshInvitations }) => {
  if (entity.type === "users") {
    return <UserRow user={entity} event={event} onRefreshInvitations={onRefreshInvitations} />;
  }
  return <GroupRow entity={entity} event={event} onRefreshInvitations={onRefreshInvitations} />;
};

export default EntityRow;
